import { render, staticRenderFns } from "./PanelWithSpeakerEditor.vue?vue&type=template&id=d5058bf8&lang=pug&"
import script from "./PanelWithSpeakerEditor.vue?vue&type=script&lang=ts&"
export * from "./PanelWithSpeakerEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithSpeakerEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports